/**
 * @file
 * Custom JS behaviour for product.
 */

(function ($) {

  Drupal.behaviors.product = {
    attach: function (context, settings) {
      // Assign bg image.
      if ($('body').hasClass('page-node-type-product')) {
        var $bg_image = $('.background-image');
        var bg_url = $bg_image.attr('data-bg');
        $bg_image.css('background-image', 'url("' + bg_url + '")');
      }
    }
  };

})(jQuery);
